

module.exports = __webpack_require__.stylable.create(
    "members1982538223",
    {"classes":{"root":"members1982538223__root","avatars":"members1982538223__avatars","avatarsSingleLayout":"members1982538223__avatarsSingleLayout","avatarsCalendarLayout":"members1982538223__avatarsCalendarLayout","avatarsListLayout":"members1982538223__avatarsListLayout","avatarsDefault":"members1982538223__avatarsDefault","avatarsOnImage":"members1982538223__avatarsOnImage","avatar":"members1982538223__avatar"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    9,
    "members1982538223",
    null
);
